export const handlelocalStorageClear = () => {
    localStorage.removeItem("_grecaptcha")
    localStorage.removeItem("user")
    localStorage.removeItem("subscriptionInfo")
    localStorage.removeItem("token")
    localStorage.removeItem("tour_enabled")
    localStorage.removeItem("userLoginCount")
    localStorage.removeItem("login_expiration_time")
}